import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import DocIcon from '../../../../../assets/icons/doc.svg';
import {getCourseLabel} from '../../../../../utils/entity/course';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {course, program} = contexts;

  const courseLabel = getCourseLabel(course);

  const isIndividual = !!course?.client_id;

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    icon: DocIcon,
    iconGradient: 'info',
    title:
      /**
       * @i18n_parser
       *
       * t('notifications:materials_disclosed.title.individual')
       * t('notifications:materials_disclosed.title.group')
       */
      i18n.t(
        `notifications:materials_disclosed.title.${
          isIndividual ? 'individual' : 'group'
        }`,
        {
          courseDates: courseLabel ? `(${courseLabel})` : '',
          courseTitle: program?.title,
        },
      ),
  };
};
